var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Price(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 63v4H14V9h33.86L61 23.22V63zm-4 0V25H46V13H18v50h39zM46.92 33.7v15.15c0 3.8-4.36 6.77-9.92 6.77s-9.92-3-9.92-6.77V34v-.32c0-3.8 4.36-6.77 9.92-6.77s9.92 2.99 9.92 6.79zm-4 15.15v-1.71a14.28 14.28 0 01-5.86 1.17 14.35 14.35 0 01-6-1.2v1.74c0 1.13 2.31 2.77 5.92 2.77s5.94-1.62 5.94-2.77zm0-6.55v-3.14A13.18 13.18 0 0137 40.47a13.18 13.18 0 01-5.92-1.31V42c0 .83 2.27 2.36 6 2.36 3.21-.05 5.31-1.2 5.84-2.06zm-.15-8.09a1.06 1.06 0 00.15-.51c0-1.13-2.31-2.77-5.92-2.77s-5.92 1.64-5.92 2.77a.84.84 0 00.06.3c.34 1.1 2.56 2.47 5.86 2.47 3.09 0 5.23-1.2 5.77-2.26z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Price.68a2b4bc.svg";
export { SvgK1Price as ReactComponent };